export const PaymentTypeEnum = {
    BANK_ACCOUNT: 'bank_account',
    MONTONIO: 'montonio',
    CASH: 'cash',
};
